import { GIVRECOEUR } from './meadow-dragon.js';
/**
 * The forest's mark of the dragon (ADR 0067, `docs/LORE.md`): after the
 * Werewolf, la Druidesse Mélisande sends the player to la Saignée, a line of
 * trees burnt in one breath; the stumps, made to speak, say which way the
 * beast flew (south-east, to the swamp); then she joins the Givrecoeur
 * Company at Havrebourg. The road east waits for her recruitment.
 */
const RANGER = { mob: 'ranger', biome: 'forest' };
const DRUID = { mob: 'forest-druid', biome: 'forest' };
export const FOREST_DRAGON_QUESTS = [
    {
        id: 'forest-dragon-scar',
        name: 'La Saignée',
        biome: 'forest',
        level: 8,
        requires: ['forest-werewolf'],
        giver: DRUID,
        turnIn: DRUID,
        offer: 'Une nuit, j’ai entendu toute une rangée d’arbres mourir d’un coup, comme quand on souffle des bougies. Aucun gobelin ne brûle la forêt comme ça. Va voir la Saignée. Les sylvains là-bas sont devenus fous de douleur. Libère-les.',
        summary: 'Rejoindre la Saignée, abattre les sylvains que la brûlure a rendus fous, puis revenir à Mélisande.',
        pending: 'La Saignée, c’est une longue ligne droite d’arbres brûlés, tu ne peux pas la rater. Les sylvains là-bas ne reconnaissent plus personne.',
        complete: 'Une ligne toute droite, et les souches fument encore… Un incendie, ça part dans tous les sens. Ça, c’est un souffle. Montre-moi l’écaille que tu portes. Oui… c’est la même odeur.',
        objectives: [
            { kind: 'reach', label: 'Atteindre la Saignée', landmark: 'La Saignée' },
            { kind: 'kill', label: 'Sylvains fous abattus', mobs: ['treant-maddened'], count: 8 },
        ],
        reward: { xp: 380, gold: 75 },
    },
    {
        id: 'forest-dragon-stumps',
        name: 'Ce que disent les souches',
        biome: 'forest',
        level: 8,
        requires: ['forest-dragon-scar'],
        giver: DRUID,
        turnIn: DRUID,
        offer: 'Les souches ont vu passer la bête, et je peux les faire parler. Mais il me faut de l’écorce de sylvain bien fraîche. Et chasse les gobelins qui fouillent les cendres : les arbres ne disent rien devant des voleurs.',
        summary: 'Rapporter de l’écorce de sylvain à Mélisande et chasser les gobelins qui pillent les cendres de la Saignée.',
        pending: 'Rapporte l’écorce des sylvains et chasse les gobelins qui pillent les cendres, là-bas, à la Saignée.',
        complete: 'Pose ta main sur la souche. Tu sens ? Elle est chaude d’un côté, le côté nord. Le dragon venait du nord et filait vers le sud-est, vers les marais. Il ne fuyait pas… il allait quelque part.',
        objectives: [
            { kind: 'collect', label: 'Écorces de sylvain', item: 'treant-bark', count: 4 },
            { kind: 'kill', label: 'Pilleurs gobelins chassés', mobs: ['goblin'], count: 12 },
        ],
        reward: { xp: 350, gold: 70, items: [{ templateId: 'forest-potion', quantity: 2 }] },
    },
    {
        id: 'forest-recruit',
        name: 'La voix des arbres',
        biome: 'forest',
        level: 8,
        requires: ['forest-dragon-stumps'],
        giver: DRUID,
        turnIn: GIVRECOEUR,
        offer: 'Ton chevalier va avoir besoin de quelqu’un pour soigner ses blessés, et ça, je sais faire. Alors je viens ! Préviens Ysolde, elle va râler. Ensuite, emmène-moi à Havrebourg.',
        summary: 'Prévenir la Garde-forestière Ysolde, puis rejoindre Ser Givrecoeur au quartier de la Compagnie, à Havrebourg.',
        pending: 'Préviens Ysolde, sur la place de Sylvebois. Puis va voir Ser Givrecoeur au quartier de la Compagnie, à Havrebourg.',
        complete: 'Une druidesse ! Je n’en avais jamais vu descendre de sa montagne. Les souches disent sud-est ? Qu’est-ce qu’un dragon va bien chercher dans les marais ? Bienvenue, Mélisande. Prends la tente du fond, c’est la moins froide.',
        objectives: [
            {
                kind: 'talk',
                label: 'Prévenir Ysolde',
                npc: RANGER,
                line: 'Mélisande s’en va ? Mais qui va me dire quand un arbre est malade, maintenant ? Bon… Dis à ton chevalier que je surveille la forêt. Et qu’il prenne soin d’elle !',
            },
        ],
        reward: { xp: 220, gold: 45 },
    },
];
//# sourceMappingURL=forest-dragon.js.map